import moment from 'moment'
import { app } from '@/main'
import { SET_CURRENT_SLIDE_MODE } from '@/vuex/types'

// mutations
import currentUser from '@/vuex/mutations/currentUser'
import currentAccount from '@/vuex/mutations/currentAccount'
import errors from '@/vuex/mutations/errors'
import folders from '@/vuex/mutations/folders'
import numbers from '@/vuex/mutations/numbers'
import indicators from '@/vuex/mutations/indicators'
import presentations from '@/vuex/mutations/presentations'
import selections from '@/vuex/mutations/selections'
import syncLoading from '@/vuex/mutations/syncLoading'
import slideActive from '@/vuex/mutations/slideActive'
import presentation from '@/vuex/mutations/presentation'
import slides from '@/vuex/mutations/slides'
import search from '@/vuex/mutations/search'
import slideGenerator from '@/vuex/mutations/slideGenerator'
import exportData from '@/vuex/mutations/exportData'
import survey from '@/vuex/mutations/survey'
import breadcrumbs from '@/vuex/mutations/breadcrumbs'

export default {
  ...currentUser,
  ...currentAccount,
  ...errors,
  ...folders,
  ...numbers,
  ...indicators,
  ...presentations,
  ...selections,
  ...syncLoading,
  ...slideActive,
  ...presentation,
  ...slides,
  ...search,
  ...slideGenerator,
  ...exportData,
  ...survey,
  ...breadcrumbs,
  // Config multiple language
  setLang: (state, payload) => {
    app.$i18n.locale = payload
    if (payload === 'br') {
      payload = 'pt_BR'
    }
    moment.locale(payload)
  },
  setPresenterLang: (state, payload) => {
    app.$i18nPresenter.locale = payload
    state.presenterLocale = payload
  },
  // Set Socket status
  setSocketDisconnected: (state, payload) => {
    state.socketDisconnect = payload
  },

  setSocketId: (state, payload) => {
    state.socketId = payload
  },

  // update sync presentation
  setSyncPresentation: (state, payload) => {
    // 1. spinning
    // 2. saved
    // 3. error

    if (state.isSyncing > 2) {
      return
    }

    state.isSyncing = payload
  },

  [SET_CURRENT_SLIDE_MODE]: (state, payload) => {
    state.currentSlideMode = payload
  },

  SET_ROUTE: (state, route) => {
    state.route = route
  },
}
